import PropTypes from 'prop-types';

import './CardPrintsList.css';

/**
 * List of cards that represents prints of some card
 * @component
 */
const CardPrintsList = ({ card, cards_list, prints_count, onSelect }) => {
	const getSelectedClass = (scry_card) => {
		// If one of cards not set
		if (!scry_card || !card) {
			return '';
		}
		// Compare scryfall IDs
		return card?.uuid === scry_card.id ? ' selected' : '';
	};

	return (
		<div className="card-print-list">
			<div className="title">
				<span className="count">{prints_count}</span>
				<span> variants of the card </span>
				<span className="card-name">{card ? card.name : ''}</span>
			</div>
			<div className="content">
				{cards_list.map((scry_card) => (
					<div
						className={'card-print' + getSelectedClass(scry_card)}
						key={scry_card.id}
						onClick={() => handleSelect(scry_card)}
					>
						<div className="collector-number">
							<span className="set-code">{scry_card.set}</span>
							<span>&nbsp;</span>
							<span className="c_number">{scry_card.collector_number}</span>
						</div>
						<div className="set-from">
							<span>set&nbsp;</span>
							<span className="set-name">{scry_card.set_name}</span>
						</div>
					</div>
				))}
			</div>
		</div>
	);

	function handleSelect(scry_card) {
		onSelect?.(scry_card);
	}
};

CardPrintsList.propTypes = {
	// Selected card
	card: PropTypes.object.isRequired,
	// Card prints
	cards_list: PropTypes.arrayOf(PropTypes.object).isRequired,
	// Number of prints
	prints_count: PropTypes.number.isRequired,
	// On select callback
	onSelect: PropTypes.func,
};

export default CardPrintsList;
